{
  "groups": {
    "main": "Hauptmenü",
    "config": "Konfiguration",
    "groupOverview": "Überblick",
    "groupWorking": "Arbeiten",
    "groupAutomation": "Automatisierung",
    "groupInfrastructure": "Infrastruktur",
    "groupSettings": "Einstellungen"
  },
  "items": {
    "buddy": "Buddy",
    "dashboard": "Dashboard",
    "health": "Gesundheit",
    "werkstatt": "Werkstatt",
    "chat": "Chat",
    "agents": "Agenten",
    "projects": "Projekte",
    "projectSettings": "Projekt-Einstellungen",
    "media": "Media",
    "vault": "Vault",
    "admin": "Admin",
    "communication": "Kommunikation",
    "teamchat": "Team-Chat",
    "vms": "VMs",
    "containers": "Container",
    "butler": "Butler",
    "llm": "LLM",
    "mcp": "MCP",
    "skills": "Skills",
    "credentials": "Credentials",
    "system": "System",
    "users": "Benutzer",
    "plugins": "Plugins",
    "extensions": "Extensions",
    "zahnfee": "Zahnfee",
    "federation": "Federation",
    "streaming": "Streaming",
    "datamining": "Datamining",
    "memory": "Memory",
    "jarvisMemory": "Jarvis-Gedächtnis",
    "wiki": "Wiki",
    "help": "Hilfe",
    "modules": "Module"
  },
  "apps_menu": "Apps",
  "sidebar": {
    "show": "Seitenleiste anzeigen",
    "hide": "Seitenleiste verstecken"
  },
  "online": "Online",
  "help_button": "Seiten-Hilfe öffnen",
  "help_label": "Hilfe",
  "update": {
    "available": "Update verfügbar — klicken zum Aktualisieren",
    "force": "Update erzwingen / Rebuild",
    "modules": "{{count}} Modul-Update(s) verfügbar — zur Modul-Verwaltung",
    "modal_title": "System-Update",
    "confirm_question": "Jetzt aktualisieren?",
    "confirm_question_force": "Update erzwingen?",
    "confirm_hint": "Der Server wird neu starten und ist für 1-2 Minuten nicht erreichbar.",
    "confirm_hint_force": "Du bist bereits auf dem aktuellen Stand. Trotzdem rebuild + restart? Server ist für 1-2 Minuten nicht erreichbar.",
    "confirm_button": "Update starten",
    "starting": "Update wird gestartet…",
    "in_progress": "Update läuft…",
    "done": "Update fertig — neue Version: {{commit}}",
    "failed": "Update fehlgeschlagen: {{error}}",
    "log_title": "Live-Log",
    "log_empty": "Noch keine Ausgabe…",
    "log_disconnected": "Server unerreichbar — warte auf Neustart…",
    "close": "Schließen",
    "stale_hint": "Auf dem Server läuft eine neuere Version. Neu laden, um alle neuen Funktionen zu sehen.",
    "reload": "Neu laden"
  },
  "restart": {
    "button": "Service neu starten",
    "modal_title": "Service-Neustart",
    "confirm_question": "Backend jetzt neu starten?",
    "confirm_hint": "Nach dem Neustart sind frisch installierte/entfernte Plugins voll wirksam. Backend ist für ~5-10 Sekunden nicht erreichbar.",
    "confirm_button": "Neustarten",
    "starting": "Restart wird gestartet…",
    "in_progress": "Backend startet neu…",
    "done": "Service läuft wieder.",
    "failed": "Restart fehlgeschlagen: {{error}}",
    "close": "Schließen",
    "now": "Jetzt neu starten"
  }
}
